<!-- 次に使える時刻表示 -->
<template>
  <div>
    <div class="label">
      <div>次に使える時刻</div>
      <div>Next time available</div>
    </div>
    <div class="value">
      {{ nextTimeAvailable }}
    </div>
  </div>
</template>

<script>
export default {
  name: "FaceNextAvailableTime",
  props: {
    nextTimeAvailable: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 11px;
  line-height: 21px;
}

.value {
  margin-top: 5px;
  font-size: 32px;
  font-weight: bold;
}
</style>
